// extracted by mini-css-extract-plugin
export default {"facilitiesTitle":"tooltipContent-module__facilitiesTitle__fJz2k","facilitiesList":"tooltipContent-module__facilitiesList__e3cRN"};